import Sidebar from './Sidebar';
import UserMenu from './UserMenu';

const IvrDts = (props) => {
    return (
        <div className="mainWrapper">
            <Sidebar key={props.inboundConnectedQueues} current="10" softphoneConnectionStatus={props.softphoneConnectionStatus} />
            <div className="main">
                <div className="headerWrapper">
                    <div className="titleWrapper">
                        <h1>Reporte Ivr Dts</h1>
                        <span class="upper">Reportes</span>
                    </div>
                    <UserMenu setInboundConnectedQueues={props.setInboundConnectedQueues} />
                </div>

                <div className="content">
                    <iframe title="Ivr Dts" src="https://kintaro.athenacampaign.com/dashdts/" style={{width: '100%', height: '80vh', border: 'none'}}></iframe>
                </div>
            </div>
        </div>
    );

}

export default IvrDts;
